import { Box } from '@mui/material';
import { useRouter } from 'next/router';
import PersistentCountdownTimer from '../CountdownTimer/PersistentCountdownTimer';
import StickyButton from '../StickyButton';
import { LayoutProps } from './Layout.interface';
const Layout: React.FC<LayoutProps> = ({
  children
}) => {
  const router = useRouter();

  // Only show timer on non-review and non-success pages
  const showTimer = !router.pathname.includes('/review') && !router.pathname.includes('/success');
  return <>
			{showTimer && <Box sx={{
      width: '100%',
      zIndex: 'auto',
      display: 'flex',
      justifyContent: 'center',
      height: 'fit-content',
      padding: '0px',
      backgroundColor: 'transparent'
    }}>
					<PersistentCountdownTimer />
				</Box>}
			{children}
			<StickyButton data-sentry-element="StickyButton" data-sentry-source-file="Layout.tsx" />
		</>;
};
export default Layout;